import { get, post } from "../services"
import { getKey } from "../helpers"

export const GENERAL = {
  getDashboardStatistics: async () => {
    let token = await getKey("token")
    let data = await get(`admin/get-dashboard-stats`)
    return data
  },
  getStatesWithHighestRegistrationAgents: async () => {
    let data = await get(`admin/states-with-highest-agent-registrations`)
    return data
  },
  getDashboardStatsLga: async () => {
    let data = await get(`admin/get-dashboard-stats-per-lga`)
    return data
  },
  getDashboardStatsState: async () => {
    let data = await get(`admin/get-dashboard-stats-per-state`)
    return data
  },
  getDashboardStatsRegional: async () => {
    let data = await get(`admin/get-dashboard-stats-per-region`)
    return data
  },
  getApprovedAgents: async () => {
    console.log("calling approved agents endpoint")
    let data = await get(`admin/get-approve-agent-states`)

    return data
  },
  getApprovedAgentsByStateId: async id => {
    let data = await post(`admin/get-approve-agent-lga`, { state_id: +id })

    return data
  },
  getApprovedRecordsByState: async ({ page, pageSize, searchKey, stateId }) => {
    let data = await get(
      `admin/get-approved-state-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  getPendingRecordsByState: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-pending-state-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getDeclinedRecordsByState: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-declined-state-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getRejectedRecordsByState: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-rejected-state-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getRecordsByLgaId: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-lga-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getApprovedAgentListPerLga: async ({ page, pageSize, searchKey, lgaId }) => {
    let data = await get(
      `admin/get-approved-agent-list-per-lga?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&lgaId=${lgaId}`
    )
    return data
  },
  getRecordByNpcId: async payload => {
    let data = await post(`admin/get-single-agent`, payload)

    return data
  },
  getStates: async () => {
    let data = await get(`resources/states`)

    return data
  },
  getLgas: async state_id => {
    let data = await get(`resources/lga?stateId=${state_id}`)

    return data
  },
  createUser: async payload => {
    let data = await post(`auth/create-user`, payload)

    return data
  },
  bulkCreateUsers: async payload => {
    let data = await post(`auth/bulk-create-users`, payload)
    return data
  },
  generateCode: async payload => {
    let data = await post(`admin/generate-agent-codes`, payload)
    return data
  },
  retriveGeneratedCodes: async payload => {
    let data = await post(`admin/retrive-generated-lga`, payload)
    return data
  },
  retriveGeneratedCodesByLga: async payload => {
    let data = await post(`admin/retrive-codes-per-lga`, payload)
    return data
  },
  markAttendance: async payload => {
    let data = await post(`admin/mark-attendance`, payload)
    console.log(data)
    return data
  },
  deleteAgentFn: async payload => {
    let data = await post(`admin/delete-agent`, payload)
    return data
  },
  ninVerifyFn: async payload => {
    let data = await post(`nin/verify`, payload)
    return data
  },
  changePwdFn: async payload => {
    let data = await post(`admin/change-password`, payload)
    return data
  },
  getAdminListFn: async ({ page, pageSize, searchKey, stateId }) => {
    const response = await get(
      `/admin/get-admins-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return response
  },
  getTrainingRecordsByStateId: async ({
    page,
    pageSize,
    searchKey,
    stateId,
  }) => {
    let data = await get(
      `admin/get-attendance-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  getTrainingRecordsByLgaId: async ({ page, pageSize, searchKey, lgaId }) => {
    let data = await get(
      `admin/get-attendance-list-lga?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&lgaId=${lgaId}`
    )
    return data
  },
  getApprovedRecordsList: async ({ page, pageSize, searchKey, stateId }) => {
    let data = await get(
      `admin/get-approved-agent-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  getPendingRecordsList: async ({ page, pageSize, searchKey, stateId }) => {
    let data = await get(
      `admin/get-pending-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  getFailedRecordsList: async ({ page, pageSize, searchKey, stateId}) => {
    let data = await get(
      `admin/get-failed-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  getDeclinedRecordsList: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-declined-agent-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getRejectedLGARecordsList: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-rejected-agent-list-per-lga?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getRejectedRecordsList: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-rejected-list?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  searchAgent: async payload => {
    let data = await post(`admin/search-agent`, payload)
    return data
  },
  getStatesThreshold: async ({ page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-states-threshold?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  getLGAsThreshold: async ({ page, pageSize, searchKey, stateId }) => {
    let data = await get(
      `admin/get-lgas-threshold?page=${page}&pageSize=${pageSize}&searchKey=${searchKey}&stateId=${stateId}`
    )
    return data
  },
  updateThreshold: async payload => {
    let data = await post(`admin/update-threshold`, payload)
    return data
  },
  // Registration counts. The ids set the level: none -> states, stateId -> LGAs,
  // stateId+lgaId -> wards (wardId/centerId would give agent records; dateFrom,
  // dateTo, page, pageSize, searchKey are optional). Unset params are dropped.
  generateInvoice: async (params = {}) => {
    const query = new URLSearchParams(
      Object.entries(params).filter(([, v]) => v != null && v !== "")
    ).toString()
    let data = await get(`admin/generate-invoice${query ? `?${query}` : ""}`)
    return data
  },
  resetAdhocPassword: async payload => {
    let data = await post(`admin/reset-adhoc-password`, payload)
    return data
  },
  deleteAdhoc: async payload => {
    let data = await post(`admin/delete-adhoc`, payload)
    return data
  },
  resetAdhocApplication: async payload => {
    let data = await post(`admin/reset-adhoc-application`, payload)
    return data
  },
  activateUser: async payload => {
    let data = await post(`admin/activate-user`, payload)
    return data
  },
  deactivateUser: async payload => {
    let data = await post(`admin/deactivate-user`, payload)
    return data
  },
  approveAgents: async payload => {
    let data = await post(`admin/approve-agents`, payload)
    return data
  },
  // National Targets — registration count targets per state (distinct from thresholds)
  getNationalTargets: async () => {
    let data = await get(`admin/national-targets`)
    return data
  },
  updateStateTarget: async payload => {
    let data = await post(`admin/update-state-target`, payload)
    return data
  },
  getNationalTargetsByState: async ({ stateId, page, pageSize, searchKey }) => {
    let data = await get(
      `admin/get-national-targets-lga?stateId=${stateId}&page=${page}&pageSize=${pageSize}&searchKey=${searchKey}`
    )
    return data
  },
  setNationalTargetLga: async payload => {
    let data = await post(`admin/set-national-target-lga`, payload)
    return data
  },
}
